import DataDokter from "@/services/DataUtility";

import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { appModule } from "./app";

export interface DokterState {
  list: Array<DokterUnit>;
  listAll: Array<DokterUnit>;
}

interface DokterUnit {
  c_doc_id: string;
  id: number;
  nama: string;
  idsp: number;
}

@Module({ store, dynamic: true, name: "storeDokter" })
class DokterStore extends VuexModule implements DokterState {
  list: Array<DokterUnit> = [];
  listAll: Array<DokterUnit> = [];
  listOnKlinik: Array<DokterUnit> = [];

  @Mutation SET_LIST_DOKTER(list: Array<DokterUnit>) {
    this.list = list;
  }

  @Mutation
  SET_LIST_DOKTER_ON_KLINIK(list: Array<DokterUnit>) {
    this.listOnKlinik = list;
  }

  @Mutation SET_ALL_DOKTER(list: Array<DokterUnit>) {
    this.list = list;
    this.listAll = list;
  }

  @Mutation
  CLEAR_ALL_LISTS() {
    this.list = [];
    this.listAll = [];
    this.listOnKlinik = [];
  }

  @Action act_dokter_all() {
    appModule.setLoading(true);
    const dt = DataDokter.getListDokterArray();

    return dt.then(dt => {
      appModule.setLoading(false);
      const ls = dt.data;
      this.SET_ALL_DOKTER(ls);
    });
  }

  @Action act_on_unit(ut: string) {
    // if (userModule.isSignedIn == true) {
    // appModule.setLoading(true);

    const dt = DataDokter.getListDokterByPoli(ut);
    dt.then(dt => {
      // appModule.setLoading(false);
      const ls = dt;
      // console.log('getListDokterByPoli', dt)
      // this.SET_LIST_DOKTER(ls);
      this.SET_LIST_DOKTER_ON_KLINIK(ls);
    });
    // } else {
    //   console.log("not active")
    // }
  }
}

export const storeDokter = getModule(DokterStore);
